import Flickity from "flickity";
import { throttle } from "throttle-debounce";

export function init() {
	const imageHero = document.querySelector(".js-hero");
	const hero = document.querySelector(".js-video-hero");
	const video = hero ? hero.querySelector(".js-hero-video") : false;
	const videoControls = document.querySelector(".js-hero-video__controls");

	if (imageHero) {
		new Flickity(imageHero, {
			arrowShape: "M30.7,20.3l-29.3,30l29.3,30 M100.7,50.3H1.4",
			autoPlay: 3000,
		});
	}

	if (!video) {
		return;
	}

	calcLayout();

	if (video) {
		if (video.readyState > 0) {
			animate();
		} else {
			video.addEventListener("loadedmetadata", animate);
		}
	}

	window.addEventListener("resize", throttle(1000, calcLayout));

	function animate() {
		window.requestAnimationFrame(() => hero.classList.add("animate"));
		setTimeout(() => {
			if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
				if (video) {
					video.play();
					videoControls.classList.add("is-playing");
				}
			}
			if (video) {
				revealvideoControls();
			}
		}, 4500);
	}

	function calcLayout() {
		let windowHeight = document.documentElement.clientHeight;
		let headerHeight = document.querySelector(".js-header").clientHeight;

		hero.style.height = `${windowHeight - headerHeight}px`;
	}

	function revealvideoControls() {
		let videoControls = document.querySelector(".js-hero-video__controls");
		videoControls.classList.add("c-hero-video__controls--reveal");
	}

	if (videoControls) {
		let videoButtonPlay = document.querySelector(
			".js-hero-video__button--play",
		);
		let videoButtonSound = document.querySelector(
			".js-hero-video__button--sound",
		);
		videoButtonPlay.addEventListener("click", toggleVideoPlay);
		videoButtonSound.addEventListener("click", toggleVideoSound);
	}

	function toggleVideoPlay() {
		if (!video) {
			return;
		}

		if (video.paused) {
			video.play();
			videoControls.classList.add("is-playing");
		} else {
			video.pause();
			videoControls.classList.remove("is-playing");
		}
	}

	function toggleVideoSound() {
		if (!video) {
			return;
		}

		console.log(video.muted);
		if (video.muted !== false) {
			video.muted = false;
			videoControls.classList.add("is-sound");
		} else {
			video.muted = true;
			videoControls.classList.remove("is-sound");
		}
	}
}
